import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import ConfirmDialog from '../../../../components/ConfirmDialog/ConfirmDialog';
import { formatDateTime } from '../../changelog/changelogAdminConfig';

/**
 * Chave geral da sequência. Ligar pede confirmação: a partir da próxima rotina (12h) os
 * modelos ligados começam a sair para as contas em teste.
 * @param {{ settings: Object, enabledCount: number, saving: boolean, onChange: Function }} props
 */
function SequenceSwitch({ settings, enabledCount, saving, onChange }) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const enabled = Boolean(settings?.enabled);

  const toggle = () => {
    if (enabled) onChange(false);
    else setConfirmOpen(true);
  };

  return (
    <Paper elevation={0} sx={{ p: { xs: 2, md: 2.5 }, mb: 3, borderRadius: '12px', border: enabled ? '1px solid #C8E6C9' : '1px solid #E2E8F0', backgroundColor: enabled ? '#FAFFFA' : '#fff' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {enabled ? 'Sequência ligada' : 'Sequência desligada'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {enabled
              ? `${enabledCount} ${enabledCount === 1 ? 'modelo ligado sai' : 'modelos ligados saem'} todo dia às 12h para as contas em teste.`
              : 'Nada sai. No cadastro, a pessoa recebe a boas-vindas padrão.'}
          </Typography>
          {settings?.updated_by && (
            <Typography variant="caption" color="text.disabled">
              Alterada por {settings.updated_by} em {formatDateTime(settings.updated_at)}
            </Typography>
          )}
        </Box>
        <Switch checked={enabled} disabled={saving} onChange={toggle} inputProps={{ 'aria-label': 'Ligar a sequência' }} />
      </Box>

      <ConfirmDialog
        isOpen={confirmOpen}
        title="Ligar a sequência?"
        message={`Os ${enabledCount} modelos ligados começam a sair na próxima rotina, às 12h, para as contas em teste. Rode a simulação antes, se ainda não rodou.`}
        confirmLabel="Ligar"
        variant="warning"
        onConfirm={() => { setConfirmOpen(false); onChange(true); }}
        onCancel={() => setConfirmOpen(false)}
      />
    </Paper>
  );
}

export default SequenceSwitch;
